// components/dashboard/StatCard.tsx
"use client";

import {
  TrendingUp,
  TrendingDown,
  DollarSign,
  ShoppingCart,
  Package,
  Users,
  LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

const ICON_MAP: Record<string, LucideIcon> = {
  DollarSign,
  ShoppingCart,
  Package,
  Users,
};

interface StatCardProps {
  stat: {
    title: string;
    value: string;
    unit: string;
    change: number;
    icon: string;
    solidColor: string; 
  };
}

export function StatCard({ stat }: StatCardProps) {
  const Icon = ICON_MAP[stat.icon];
  const isPositive = stat.change >= 0;

  return (
    <div className="materio-card p-5 flex flex-col justify-between h-full">
      <div className="flex items-center justify-between mb-4">
        <div className={cn("w-12 h-12 rounded-lg flex items-center justify-center text-white", stat.solidColor)}>
          <Icon className="h-6 w-6" strokeWidth={2} />
        </div>
        
        <div className={cn(
          "flex items-center gap-1 text-[13px] font-bold",
          isPositive ? "text-emerald-500" : "text-red-500"
        )}>
          {isPositive ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
          {isPositive ? "+" : ""}{stat.change}٪
        </div>
      </div>

      <div>
        <p className="text-sm text-muted-foreground font-medium mb-1">
          {stat.title}
        </p>
        <div className="flex items-baseline gap-1.5">
          <h3 className="text-2xl font-bold tracking-tight text-foreground">
            {stat.value}
          </h3>
          <span className="text-xs text-muted-foreground">{stat.unit}</span>
        </div>
      </div>
    </div>
  );
}